angular.module('bmsApp.crm.salespipeline')
	.controller('SalesPipelineMainCtrl', function ($state,
												   $scope) {

		$scope.$on('SalesPipelineOverview', function (e, pipelineData) {
			$scope.pipelineData = pipelineData;
		});

	});